import styles from './spinner.module.css';

export function Spinner() {
	return (
		<div className={styles.loadingOverlay}>
			<div className={styles.spinner} />
		</div>
	);
}
